import { Button, Col } from "react-bootstrap";
import { z } from "zod";
import { Input, StatefulForm, useStatefulForm } from "../../component-library";
import { useProfileQuery } from "../../queries";
import { UpdateProfilePasswordRequest } from "../../models";
import { useMemo } from "react";

const schema = z
    .object({
        currentPassword: z.string().min(1, "Required"),
        newPassword: z.string().min(10, "Password should be at least 10 characters"),
        newPasswordConfirm: z.string().min(10, "Password should be at least 10 characters"),
    })
    .refine((data) => data.newPassword === data.newPasswordConfirm, {
        message: "Passwords must match",
        path: ["newPasswordConfirm"],
    });

type PasswordForm = z.infer<typeof schema>;

type UpdatePasswordFormProps = {
    emailAddress: string;
};

export const UpdatePasswordForm = ({ emailAddress }: UpdatePasswordFormProps) => {
    const { updatePasswordMutation } = useProfileQuery();

    const onSubmit = (values: PasswordForm) => {
        const request: UpdateProfilePasswordRequest = {
            ...values,
            emailAddress,
        };
        updatePasswordMutation.mutate(request);
    };

    const defaultValues = useMemo(() => ({ currentPassword: "", newPassword: "", newPasswordConfirm: "" }), []);

    const { methods, isDirty } = useStatefulForm({ schema, defaultValues });

    return (
        <StatefulForm onSubmit={(values) => onSubmit(values as PasswordForm)} methods={methods}>
            <Col className="d-flex flex-column">
                <Input accessor="currentPassword" label="Current Password" type="password" />
                <Input accessor="newPassword" label="New Password" type="password" />
                <Input accessor="newPasswordConfirm" label="Confirm New Password" type="password" />
                <Button type="submit" className="align-self-center" disabled={!isDirty}>
                    Submit
                </Button>
            </Col>
        </StatefulForm>
    );
};
